import { timeFormatter } from '../../utils/formatters/time.formatter.js';
import { REFI_LOGIN_CONST } from '../../constants/login.constants.js';

/* eslint-disable no-console */
export class DebugService {
  constructor(classname) {
    this.classname = classname ? `${classname}::` : classname;
    this.blnDebug = window.location.host.indexOf(':4211') > -1 || window.location.host.includes('autorefi-ext-preprod.capitalone.com') || window.location.host.includes('coaf-refi-web-ui-qa.capitalone.com') || REFI_LOGIN_CONST.isNonProdEnv();
    this.blnHasConsole = false;
    this.defaultClassname = 'No Classname::';
  }

  log(pMessage, pObject) {
    if (this.classname === null || this.classname === undefined) {
      this.classname = this.defaultClassname;
    }
    if (this.blnDebug && this.checkForConsole()) {
      const timestr = timeFormatter();
      if (pObject !== null && pObject !== undefined) {
        console.info(this.classname, pMessage, pObject, timestr);
      } else {
        console.info(this.classname, pMessage, timestr);
      }
    }
  }

  checkForConsole() {
    this.blnHasConsole = true;
    try {
      console.log();
    } catch (er) {
      this.blnHasConsole = false;
    }
    return this.blnHasConsole;
  }
}
